import { DataCompressionInfo } from '../client';
import { lz4_decompress } from './lz4';
export async function decompress(buffer, codec) {
    if (!codec)
        return buffer;
    switch (codec) {
        case DataCompressionInfo.IDENTITY:
            return buffer;
        case DataCompressionInfo.XLZ4:
            return lz4_decompress(buffer);
        default:
            throw new Error(`Invalid decompression codec: ${codec}`);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVjb21wcmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvY29tcHJlc3Npb24vZGVjb21wcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsbUJBQW1CLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFL0MsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLE9BQU8sQ0FBQTtBQUV0QyxNQUFNLENBQUMsS0FBSyxVQUFVLFVBQVUsQ0FDOUIsTUFBMEIsRUFDMUIsS0FBMkI7SUFFM0IsSUFBSSxDQUFDLEtBQUs7UUFBRSxPQUFPLE1BQU0sQ0FBQTtJQUN6QixRQUFRLEtBQUssRUFBRSxDQUFDO1FBQ2QsS0FBSyxtQkFBbUIsQ0FBQyxRQUFRO1lBQy9CLE9BQU8sTUFBTSxDQUFBO1FBQ2YsS0FBSyxtQkFBbUIsQ0FBQyxJQUFJO1lBQzNCLE9BQU8sY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQy9CO1lBQ0UsTUFBTSxJQUFJLEtBQUssQ0FBQyxnQ0FBZ0MsS0FBSyxFQUFFLENBQUMsQ0FBQTtJQUM1RCxDQUFDO0FBQ0gsQ0FBQyJ9